<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Add Role</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content class="add-role-dialog-content">
      <mat-form-field class="flex-full">
        <mat-label>Name</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="name" id="name" required />
        @if (form.get('name')?.hasError('required')) {
          <mat-error> Name is Required. </mat-error>
        }
        @if (!form.get('name')?.hasError('required') && form.get('name')?.hasError('noContent')) {
          <mat-error
            >Name must contain characters.</mat-error
            >
          }
          @if (form.get('name')?.hasError('maxlength')) {
            <mat-error>
              Name must be less than 50 characters
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="flex-full">
          <mat-label>Description</mat-label>
          <input matInput autocomplete="off" type="text" formControlName="description" id="description" />
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
    </form>
  </lcs-loading-overlay>
